const DONUT_HALF_ANGLE_RANGES = Array.from({ length: 4 }, (_, i) => {
    const offset = -Math.PI / 2 + i * Math.PI / 2;
    return [offset, offset + Math.PI];
});
const [DONUT_HALF_ANGLE_RANGE_TOP, DONUT_HALF_ANGLE_RANGE_RIGHT, DONUT_HALF_ANGLE_RANGE_BOTTOM, DONUT_HALF_ANGLE_RANGE_LEFT,] = DONUT_HALF_ANGLE_RANGES;

export { DONUT_HALF_ANGLE_RANGES, DONUT_HALF_ANGLE_RANGE_BOTTOM, DONUT_HALF_ANGLE_RANGE_LEFT, DONUT_HALF_ANGLE_RANGE_RIGHT, DONUT_HALF_ANGLE_RANGE_TOP };
//# sourceMappingURL=constants.js.map
